import React from 'react';
import ContactForm from './components/ContactForm';
import './styles.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src="images/summit_logo.png" alt="Summit Logo" className="logo" />
        <p className="App-header-subtitle">
          Welcome to Summit Real Estate
        </p>
        <p className="App-header-intro">
          Luxury Apartment Homes Across the Pacific Northwest
        </p>
        <hr className="divider" />
        <p className="intro-text">
          Experience comfort, style, and attention to detail across our collection of luxury apartment homes.

          From spacious floor plans and designer finishes to vibrant community spaces, Summit Real Estate Management offers the perfect blend of sophistication and ease.
        </p>
        <p className="intro-text">
          If you’ve found a home that fits your lifestyle, please complete the brief form below to start your application process.

        Once submitted, a property manager will reach out to confirm availability and guide you through the next steps.
        </p>
      
        <br />
        <h1>Application Request</h1>
      </header>
      <main>
        <ContactForm />
      </main>
    </div>
  );
}

export default App;